"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getColor", {
  enumerable: true,
  get: function () {
    return _getColor.default;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _menu = _interopRequireDefault(require("cccisd-icons/svg/menu"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactColor = require("react-color");

var _style = _interopRequireDefault(require("./style.css"));

var _color = _interopRequireDefault(require("color"));

var _colors = _interopRequireDefault(require("./colors.css"));

var _getColor = _interopRequireDefault(require("./getColor.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const appColors = [{
  name: 'primaryColor'
}, {
  name: 'successColor'
}, {
  name: 'infoColor'
}, {
  name: 'warningColor'
}, {
  name: 'dangerColor'
}];
/** Color picker */

const CccisdColorPicker = props => {
  const {
    value,
    onChange
  } = props;
  const [showColorPicker, setDisplayColorPicker] = (0, _react.useState)(false);
  const [color, setColor] = (0, _react.useState)(value && value.startsWith('#') ? value : '#666666');

  const toggleColorPicker = () => {
    onChange(color);
    setDisplayColorPicker(!showColorPicker);
  };

  const isLight = (0, _color.default)(color).luminosity() > 0.5;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _style.default.wrapper
  }, appColors.map(item => /*#__PURE__*/_react.default.createElement("div", {
    key: item.name,
    className: (0, _classnames.default)(_style.default.color, {
      [_style.default.selected]: value === item.name
    }),
    style: {
      backgroundColor: _colors.default[item.name]
    },
    onClick: () => {
      setDisplayColorPicker(false);
      onChange(item.name);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_style.default.more, {
      [_style.default.show]: showColorPicker
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _style.default.cover,
    onClick: () => setDisplayColorPicker(false)
  }), /*#__PURE__*/_react.default.createElement(_reactColor.ChromePicker, {
    disableAlpha: true,
    color: color,
    onChange: obj => {
      setColor(obj.hex);
      onChange(obj.hex);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_style.default.color, _style.default.customColor, {
      [_style.default.selected]: value && value.startsWith('#'),
      [_style.default.light]: isLight
    }),
    style: {
      backgroundColor: color
    },
    onClick: toggleColorPicker
  }, /*#__PURE__*/_react.default.createElement(_menu.default, null))));
};

CccisdColorPicker.propTypes = {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func
};
CccisdColorPicker.defaultProps = {
  onChange: () => {}
};
var _default = CccisdColorPicker;
exports.default = _default;